/* nubilua — interacciones */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.nb-reveal:not(.nb-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('nb-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('nb-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initEstrellas() {
    document.querySelectorAll('.nb-estrellas:not([data-ok])').forEach(function (cont) {
      cont.setAttribute('data-ok', '1');
      var n = parseInt(cont.getAttribute('data-n') || '60', 10);
      if (window.innerWidth < 600) n = Math.round(n * 0.55);
      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var s = document.createElement('span');
        s.className = 'nb-estrella' + (Math.random() < 0.12 ? ' nb-estrella--oro' : '');
        s.style.left = (Math.random() * 100) + '%';
        s.style.top = (Math.random() * 100) + '%';
        s.style.setProperty('--d', (2.5 + Math.random() * 4).toFixed(2) + 's');
        s.style.setProperty('--r', (-Math.random() * 6).toFixed(2) + 's');
        frag.appendChild(s);
      }
      cont.appendChild(frag);
    });
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-nb-parallax]');
    if (!imgs.length || reduce) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var k = parseFloat(img.getAttribute('data-nb-parallax')) || 0;
        var r = img.getBoundingClientRect(); var im = img.querySelector('img'); if (!im) return;
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        im.style.transform = 'translate3d(0,' + (-r.top * k / 100).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  function initComparador() {
    document.querySelectorAll('.nb-comp:not([data-ok])').forEach(function (c) {
      c.setAttribute('data-ok', '1');
      var r = c.querySelector('.nb-comp__rango');
      if (!r) return;
      var set = function (v) { c.style.setProperty('--pos', v + '%'); };
      r.addEventListener('input', function () { set(r.value); });
      set(r.value);
      if (!reduce && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return;
          io.disconnect();
          var start = null, from = 88, to = parseFloat(r.value);
          function step(t) {
            if (!start) start = t;
            var p = Math.min((t - start) / 1400, 1), e = 1 - Math.pow(1 - p, 3);
            var v = from + (to - from) * e; set(v); if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        }, { threshold: 0.5 });
        io.observe(c);
      }
    });
  }

  function initModos() {
    document.querySelectorAll('.nb-modos:not([data-ok])').forEach(function (m) {
      m.setAttribute('data-ok', '1');
      var btns = m.querySelectorAll('.nb-modo'), imgs = m.querySelectorAll('.nb-modos__img'), visor = m.querySelector('.nb-modos__visor');
      var auto = parseInt(m.getAttribute('data-auto') || '0', 10), idx = 0, timer = null;
      function go(i) {
        idx = i;
        btns.forEach(function (b, j) { b.classList.toggle('is-activa', j === i); b.setAttribute('aria-pressed', j === i); });
        imgs.forEach(function (im, j) { im.classList.toggle('is-activa', j === i); });
        if (visor && btns[i]) visor.style.setProperty('--nb-glow', btns[i].getAttribute('data-glow'));
      }
      btns.forEach(function (b, j) { b.addEventListener('click', function () { go(j); if (timer) { clearInterval(timer); timer = null; } }); });
      go(0);
      if (auto > 0 && !reduce && btns.length > 1) timer = setInterval(function () { go((idx + 1) % btns.length); }, auto * 1000);
    });
  }

  function initGaleria() {
    document.querySelectorAll('.nb-galeria:not([data-ok])').forEach(function (g) {
      g.setAttribute('data-ok', '1');
      var main = g.querySelector('.nb-galeria__principal img'), minis = g.querySelectorAll('.nb-galeria__mini');
      if (!main || !minis.length) return;
      var idx = 0;
      function go(i) {
        idx = (i + minis.length) % minis.length;
        var b = minis[idx];
        main.classList.add('is-cambiando');
        setTimeout(function () {
          main.src = b.getAttribute('data-src'); main.srcset = b.getAttribute('data-srcset') || '';
          main.alt = b.getAttribute('data-alt') || '';
          main.classList.remove('is-cambiando');
        }, 180);
        minis.forEach(function (m, j) { m.classList.toggle('is-activa', j === idx); });
        var cont = g.querySelector('[data-nb-n]'); if (cont) cont.textContent = idx + 1;
        var fila = b.parentElement; fila.scrollTo({ left: b.offsetLeft - fila.offsetLeft - fila.clientWidth / 2 + b.clientWidth / 2, behavior: 'smooth' });
      }
      minis.forEach(function (b, j) { b.addEventListener('click', function () { go(j); }); });
      var p = g.querySelector('.nb-galeria__flecha--izq'), n = g.querySelector('.nb-galeria__flecha--der');
      if (p) p.addEventListener('click', function () { go(idx - 1); });
      if (n) n.addEventListener('click', function () { go(idx + 1); });
      var x0 = null;
      main.parentElement.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.parentElement.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1)); x0 = null;
      });
    });
  }

  function initCantidad() {
    document.querySelectorAll('.nb-cantidad:not([data-ok])').forEach(function (q) {
      q.setAttribute('data-ok', '1');
      var i = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(i.value || '1', 10) + parseInt(b.getAttribute('data-d'), 10);
          i.value = Math.max(1, v);
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-nb-producto]:not([data-ok])').forEach(function (root) {
      root.setAttribute('data-ok', '1');
      var dataEl = root.querySelector('script[data-nb-variantes]');
      var selects = root.querySelectorAll('.nb-variantes select');
      if (!dataEl || !selects.length) return;
      var variants = JSON.parse(dataEl.textContent);
      var money = root.getAttribute('data-money') || '{{amount}} €';
      function fmt(c) {
        var n = (c / 100).toFixed(2);
        return money.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
          if (k.indexOf('comma') > -1) return n.replace('.', ',');
          if (k.indexOf('no_decimals') > -1) return String(Math.round(c / 100));
          return n;
        });
      }
      function update() {
        var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        var btns = root.querySelectorAll('[data-nb-add]');
        var idInput = root.querySelector('input[name="id"]');
        if (!v) { btns.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = root.getAttribute('data-txt-nodisp'); }); return; }
        if (idInput) idInput.value = v.id;
        root.querySelectorAll('[data-nb-precio]').forEach(function (e) { e.textContent = fmt(v.price); });
        root.querySelectorAll('[data-nb-antes]').forEach(function (e) { e.textContent = v.compare_at_price > v.price ? fmt(v.compare_at_price) : ''; });
        btns.forEach(function (b) { b.disabled = !v.available; b.querySelector('span').textContent = v.available ? root.getAttribute('data-txt-add') : root.getAttribute('data-txt-agotado'); });
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      }
      selects.forEach(function (s) { s.addEventListener('change', update); });
    });
  }

  function initBarra() {
    var barra = document.querySelector('.nb-barra'), ref = document.querySelector('[data-nb-form-principal]');
    if (!barra || !ref || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      var e = en[0]; barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(ref);
  }

  /* Añadir al carrito con el cajón de Dawn (si existe); si no, envío normal del formulario */
  function initCarrito() {
    document.querySelectorAll('form.nb-form-ajax:not([data-ok])').forEach(function (form) {
      form.setAttribute('data-ok', '1');
      form.addEventListener('submit', function (ev) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function' || !window.routes) return;
        ev.preventDefault();
        var btn = form.querySelector('[data-nb-add]');
        if (btn) { btn.disabled = true; btn.classList.add('is-cargando'); }
        var fd = new FormData(form);
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
        fetch(window.routes.cart_add_url, { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' } })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { mostrarError(form.closest('[data-nb-producto]'), res.description || res.message); return; }
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-cargando'); } });
      });
    });
  }

  function initVideos() {
    document.querySelectorAll('video.nb-video__media:not([data-ok])').forEach(function (v) {
      v.setAttribute('data-ok', '1');
      v.muted = true; v.setAttribute('playsinline', ''); v.loop = true;
      var p0 = v.play(); if (p0 && p0.catch) p0.catch(function () {});
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (e) { if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } });
        }, { threshold: 0.4 }).observe(v);
      }
      var b = v.parentElement.querySelector('[data-nb-sonido]');
      if (b) b.addEventListener('click', function () {
        v.muted = !v.muted; b.classList.toggle('is-on', !v.muted);
        b.setAttribute('aria-label', v.muted ? 'Activar sonido' : 'Silenciar');
        if (!v.muted) { document.querySelectorAll('video.nb-video__media').forEach(function (o) { if (o !== v) { o.muted = true; var ob = o.parentElement.querySelector('[data-nb-sonido]'); if (ob) ob.classList.remove('is-on'); } }); v.play(); }
      });
    });
  }

  function mostrarError(root, msg) {
    var e = root && root.querySelector('[data-nb-error]');
    if (e) { e.textContent = msg; e.hidden = false; setTimeout(function () { e.hidden = true; }, 6000); } else { alert(msg); }
  }

  /* Comprar ahora: añade al carrito y va directo al pago */
  function initComprar() {
    document.querySelectorAll('[data-nb-comprar]:not([data-ok])').forEach(function (b) {
      b.setAttribute('data-ok', '1');
      b.setAttribute('data-nb-inicial', b.disabled ? 'off' : 'on');
      b.addEventListener('click', function () {
        var root = b.closest('[data-nb-producto]') || document;
        var form = root.querySelector('form.nb-form-ajax');
        if (!form) return;
        var fd = new FormData(form);
        b.disabled = true;
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) { mostrarError(root, res.j.description || res.j.message || 'No se ha podido añadir al carrito.'); b.disabled = false; return; }
            window.location.href = '/checkout';
          })
          .catch(function () { mostrarError(root, 'No se ha podido conectar. Inténtalo de nuevo.'); b.disabled = false; });
      });
    });
  }

  /* Al volver atrás desde el checkout, el navegador restaura la página con el botón aún desactivado */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-nb-comprar][data-nb-inicial="on"]').forEach(function (b) { b.disabled = false; });
  });

  function initPacks() {
    document.querySelectorAll('.nb-packs:not([data-ok])').forEach(function (g) {
      g.setAttribute('data-ok', '1');
      var root = g.closest('[data-nb-producto]') || document;
      var qty = root.querySelector('form.nb-form-ajax input[name="quantity"]');
      g.querySelectorAll('[data-nb-pack]').forEach(function (b) {
        b.addEventListener('click', function () {
          g.querySelectorAll('[data-nb-pack]').forEach(function (o) { o.classList.toggle('is-activo', o === b); o.setAttribute('aria-checked', o === b); });
          if (qty) qty.value = b.getAttribute('data-nb-pack');
        });
      });
    });
  }

  function initAll() {
    initEstrellas(); initReveal(); initParallax(); initComparador(); initModos();
    initGaleria(); initCantidad(); initVariantes(); initBarra(); initCarrito(); initVideos(); initComprar(); initPacks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
